import { render, staticRenderFns } from "./FecData.vue?vue&type=template&id=bc43f138&"
import script from "./FecData.vue?vue&type=script&lang=js&"
export * from "./FecData.vue?vue&type=script&lang=js&"
import style0 from "./FecData.vue?vue&type=style&index=0&id=bc43f138&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports